module.exports = __webpack_public_path__ + "img/lento.91c245ae.jpg";